<template>
  <vacancy-videointerview-groups v-if="loaded" />

  <div v-else-if="error" class="error">
    <span class="error-text">{{ $tr('responses.tags.distributionRules.rulesError') + error }}</span>
    <vbutton class="button" label="responses.tags.refresh" @click="load" />
  </div>

  <vpreloader v-else width="2" size="64" />
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import VacancyVideointerviewGroups from './components/groups.vue';

const { mapActions, mapGetters } = createNamespacedHelpers('vacancy_new/video_interview_groups');

export default {
  name: 'VacancyVideointerviewGroupsContainer',
  components: { VacancyVideointerviewGroups },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.$store.getters['vacancy_new/modules/allow_vi_question_random'] === false) {
        next({ name: 'vacancy_video_base' });
      }
    });
  },

  props: {
    vacancyId: {
      type: [String, Number],
      required: true
    }
  },

  computed: {
    ...mapGetters({
      loaded: 'loaded',
      error: 'error'
    })
  },

  beforeMount() {
    this.load();

    if (!this.$store.getters['vacancy/videointerview/one'].id) {
      this.$store.dispatch('vacancy/videointerview/fetch', {
        vacancyId: this.vacancyId
      });
    }
  },

  methods: {
    ...mapActions({ load: 'load' })
  }
};
</script>

<style lang="scss" scoped>
.error {
  padding: 5px 0;

  .error-text {
    font-size: 14px;
    color: $red;
  }

  .button {
    margin-left: 5px;
  }
}
</style>
